// extracted by mini-css-extract-plugin
module.exports = {"content":"Post-module--content--1XF47","text":"Post-module--text--3OpEy"};